import { useContext } from 'react'

import TrainingPortalThemeContext from 'contexts/TrainingPortalThemeContext'

const useTrainingPortalTheme = () => useContext(TrainingPortalThemeContext)

export default useTrainingPortalTheme
